import { PageBase } from 'frontend/common-imports'
import clickToPlayWrap from 'lib/click-to-play-wrap'
import Glide, { Controls, Autoplay, Swipe, Lazy, GLIDE_SETTINGS } from 'frontend/lib/glide/bundle'

export default class LocationPage extends PageBase {
  static renderSlider () {
    new Glide('.images_slider',
      Object.assign(
        GLIDE_SETTINGS,
        {
          autoplay: 6000,
          hoverstor: true,
        },
      ),
    ).mount({ Swipe, Controls, Autoplay, Lazy })
  }

  static handleDOMReady () {
    document.querySelectorAll('.about_location .video_container').forEach(el => clickToPlayWrap(el))
  }

  static handleStylesApplied () {
    this.renderSlider()
  }
}

LocationPage.init()
